import { el, setChildren } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

import {
  buildActivityForDisplay
} from 'root/startup-view/calendar/details/utilities';
import {
  convertParticipantsToContacts
} from 'root/startup-view/calendar/utilities';

import PublicMeetingEditor from './public-meeting-editor';
import ActivityNotExistsView from './activity-not-exists-view';

import './index.scss';

class PublicAppointmentView {

  constructor(configuration) {

    this.activityId = configuration.activityId;
    this.activity = null;

    this.el = el('#public-appointment-view-main', [
      el('ht-spinner')
    ]);

  }

  displayActivity() {

    const updatorPanel = new PublicMeetingEditor({
      meeting: this.activity.event,
      onSave: this.rescheduleMeeting.bind(this),
      onCancel: this.cancelMeeting.bind(this),
      readOnly: true,
      onRemindersChange: this.handleRemindersChange.bind(this)
    });

    setChildren(this.el, [updatorPanel]);

  }

  displayActivityNotExistsView() {

    setChildren(this.el, [new ActivityNotExistsView()]);

  }

  async loadActivity() {

    const result = await serverInterface.startup.publicCalendarActivities.getPopulatedActivityById(this.activityId);

    this.activity = buildActivityForDisplay(result);

    this.activity.event.attendees = convertParticipantsToContacts(this.activity.event.attendees);

  }

  async initialize() {

    try {

      await this.loadActivity();

      this.displayActivity();

    } catch (exception) {
      this.displayActivityNotExistsView();
      if (exception.code !== 'CALENDAR_ACTIVITY_NOT_FOUND') {
        // eslint-disable-next-line no-console
        console.error(exception);
      }

    }

  }

  async rescheduleMeeting(data) {

    try {

      await serverInterface.startup.publicCalendarActivities.meetings.rescheduleMeeting(this.activity._id, this.activity.event._id, data);

      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Appointment rescheduled successfully!',
        seconds: 5,
        type: 'info'
      });

    } catch (exception) {

      if (exception.code === 'SLOTS_ALREADY_BLOCKED' || exception.code === 'ValidationError') {
        application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
          message: 'User is not available in the selected time. Please try different timings!',
          seconds: 5,
          type: 'error'
        });
      } else {
        throw exception;
      }

    }

  }

  async cancelMeeting() {

    await serverInterface.startup.publicCalendarActivities.meetings.cancelMeeting(this.activity._id, this.activity.event._id);

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: 'Appointment cancelled successfully!',
      seconds: 5,
      type: 'info'
    });

  }

  async handleRemindersChange(event) {

    const activityId = this.activity._id;
    const reminder = event.reminder;

    if (event.type === 'added') {
      const newReminder = await serverInterface.startup.publicCalendarActivities.reminders.setupReminder(activityId, event.reminder);
      reminder._id = newReminder._id;
    } else if (event.type === 'updated') {
      serverInterface.startup.publicCalendarActivities.reminders.updateReminderById(activityId, reminder._id, reminder);
    } else {
      serverInterface.startup.publicCalendarActivities.reminders.deleteReminderById(activityId, reminder._id);
    }

  }

  onmount() {

    this.initialize();

  }

}

export default PublicAppointmentView;